import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faCreditCard,faHeadset, faMoneyCheckDollar,faPlane,} from "@fortawesome/free-solid-svg-icons";

export const Facility = () => {
  return (
    <section className="facility bg-1 py-2">
        <div className="container py-5">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-3 col-6" data-aos="fade-up" data-aos-duration="1000">
              <div className="facility-box">
                <div className="icon">
                  <FontAwesomeIcon icon={faPlane} />
                </div>
                <p>Free Shipping World Wide</p>
              </div>
            </div>
            <div className="col-lg-3 col-6" data-aos="fade-up" data-aos-duration="1500">
              <div className="facility-box">
                <div className="icon">
                  <FontAwesomeIcon icon={faMoneyCheckDollar} />
                </div>
                <p>100% MONEY BACK GUARANTEE</p>
              </div>
            </div>
            <div className="col-lg-3 col-6" data-aos="fade-up" data-aos-duration="1800">
              <div className="facility-box">
                <div className="icon">
                  <FontAwesomeIcon icon={faCreditCard} />
                </div>
                <p>MANY PAYMENT GATEWAYS</p>
              </div>
            </div>
            <div className="col-lg-3 col-6" data-aos="fade-up" data-aos-duration="2200">
              <div className="facility-box">
                <div className="icon">
                  <FontAwesomeIcon icon={faHeadset} />
                </div>
                <p>24/7 ONLINE SUPPORT</p>
              </div>
            </div>
          </div>
        </div>
    </section>
  )
}